import type { RbacAssignableAdmin, RealEstateDeveloperOption } from '@gozoki/api-types'
import { queryOptions } from '@tanstack/react-query'
import { gozokiApiWithAuth } from '../gozokiApi'

/**
 * Deux annuaires minimaux, servis par des routes gardées par le tuple de l'écran appelant, pour
 * remplacer deux usages détournés (audit RBAC du 19/09) :
 *
 * - `GET /rbac/assignable-admins` (`edit roles-admin.roles.admin-assignment`) remplace
 *   `GET /users/index-bo` (`read users.bo-users.user`) dans le dialogue « Assigner des
 *   utilisateurs » — MAJ-05 ;
 * - `GET /real-estate/developers` (`read real-estate.kanban.project`) remplace
 *   `GET /rbac/roles` dans le sélecteur de développeur d'un projet foncier — M2 / M3 / TAX-B1.
 */

export const fetchRbacAssignableAdmins = async () => {
  const response = await gozokiApiWithAuth.get<RbacAssignableAdmin[]>('/rbac/assignable-admins')
  return response.data
}

export const getRbacAssignableAdminsOptions = () =>
  queryOptions({
    queryKey: ['rbac', 'assignable-admins'] as const,
    queryFn: fetchRbacAssignableAdmins,
  })

export const fetchRealEstateDevelopers = async () => {
  const response =
    await gozokiApiWithAuth.get<RealEstateDeveloperOption[]>('/real-estate/developers')
  return response.data
}

export const getRealEstateDevelopersOptions = () =>
  queryOptions({
    queryKey: ['real-estate', 'developers'] as const,
    queryFn: fetchRealEstateDevelopers,
  })
